module.exports = __webpack_public_path__ + "img/sl.af0884d4.svg";